import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './langs'
import ElementLocale from 'element-ui/lib/locale'
import {getLanguage,setLanguage} from '@/assets/js/config';
Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: getLanguage(),
    messages
})
ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n
